import { Form } from 'antd';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { SCREEN_NAME } from 'infrastructure/config/CONSTANTS';
import { PageTitle } from 'presentation/components/PageTitle';
import Content from './components/Content';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
};

const CU05302Page = ({ simualteUseCase, masterUseCase }: props) => {
    const [form] = Form.useForm();

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-053-02-container"
        >
            <PageTitle title={SCREEN_NAME['CU-053-02']} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                    marginBottom: 60,
                }}
            >
                <Content form={form} service={simualteUseCase} masterUseCase={masterUseCase} />
            </section>
        </div>
    );
};

export default CU05302Page;
